import { render, staticRenderFns } from "./InboxDropDown.vue?vue&type=template&id=3b4ac9e6&scoped=true&"
import script from "./InboxDropDown.vue?vue&type=script&lang=js&"
export * from "./InboxDropDown.vue?vue&type=script&lang=js&"
import style0 from "./InboxDropDown.vue?vue&type=style&index=0&id=3b4ac9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ac9e6",
  null
  
)

export default component.exports